var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-4",attrs:{"fluid":""}},[_c('h3',{staticClass:"mb-4"},[_vm._v("پروفایل")]),_c('profile-component',{attrs:{"submit":_vm.updateProfile,"form":_vm.profile,"changeRole":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }